// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"365":"7024a4bc","627":"cedbb853"}[chunkId] + ".chunk.css";
};